module.exports = __webpack_public_path__ + "static/iso_8.ed4079c7.png";